import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import GeoCoder from '../components/GeoCoder';
import { isJwtExpired } from 'jwt-check-expiration';


const JobDetails = () => {
  const [message, setMessage] = useState('');
   const navigate = useNavigate();
   const token = sessionStorage.getItem('jwtToken'); // Retrieve JWT token from localStorage
    console.log('JWT token retrieved:', token);
    //console.log('isExpired is:', isJwtExpired(token));
  
/* const linkLng = 103.90433333333334;
const linkLat = 1.3993056; */
  useEffect(() => {

    const apiUrl = process.env.REACT_APP_API_URL;
    

    // Make an HTTP GET request to the backend API
    // axios.get(`${apiUrl}/users/jobdetails`, 
    axios.get('http://muvitapp.com/webapp5/', 
      {
        headers: {
          "Authorization": `Bearer ${token}`,  // Attach JWT token to Authorization header
          
          //"Content-Type": "application/json"    // Optional: You can specify other headers if needed
        }
      }
    )
    
      .then(response => {
        setMessage(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
      });
  }, []);

  if(token==null || isJwtExpired(token)) {
        return(
            <p className="text-center">You need to be logged in.</p>
        )
      }

  return (
    <div>
<h1>Message from Backend: {message}</h1>
<hr/>
      <h1>Job Details for job id</h1>

      {/* <a href={"https://www.google.com/maps/?q=" + this.state.linkLat + "," +
    this.state.linkLng} target="_blank"><img alt="gmap" src={gmap}/></a> */}



{/* <p><a href="https://www.waze.com/ul?ll=40.75889500%2C-73.98513100&navigate=yes&zoom=17">Start Trip</a></p>
<p><a href="https://waze.com/ul?q=66%20Acacia%20Avenue&ll=45.6906304,-120.810983&navigate=yes">Start Trip</a></p>
   <p><a href={`https://waze.com/ul?ll=${this.state.linkLat},${this.state.linkLng}&navigate=yes`} >Open in Waze</a></p> 
   <p><a href={`https://waze.com/ul?ll=${linkLat},${linkLng}&navigate=yes`} >Start Trip</a></p>

   <p><a href={"https://waze.com/ul?q=Bedok%20Reservoir%20Road&navigate=yes"} >Start Trip</a></p> */}

   
      <GeoCoder/>

      
      
      <div /* className={styles.allButtons} */>
                    <button
                      className="btn btn-primary"
                      onClick={(event) => {
                        event.preventDefault();
                        //navigate(`/jobdetails/${job.id}`);
                        navigate('/delivery');
                      }}
                      type="button"
                    >
                      ⬅️
                    </button>
                    
                  </div>

    </div>
  );
};

export default JobDetails;
